import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import {
  compareScreenDrift,
  fetchScreenDriftGrouped,
  ignoreLocator,
} from '../../services/locatorDriftService';
import { loadDriftIgnoreListAsync } from './locatorCoreSlice';
import { errorMessage } from './locatorDriftUtils';

export const fetchScreenDriftGroupedAsync = createAsyncThunk(
  'locatorDrift/screen/fetchGrouped',
  async (_, { rejectWithValue }) => {
    try {
      return await fetchScreenDriftGrouped();
    } catch (error) {
      return rejectWithValue(errorMessage(error));
    }
  },
);

export const compareScreenDriftAsync = createAsyncThunk(
  'locatorDrift/screen/compare',
  async (payload, { rejectWithValue }) => {
    try {
      return await compareScreenDrift(payload);
    } catch (error) {
      return rejectWithValue(errorMessage(error));
    }
  },
);

export const addIgnoredLocatorAsync = createAsyncThunk(
  'locatorDrift/screen/addIgnoredLocator',
  async ({ by, value }, { dispatch, rejectWithValue }) => {
    try {
      await ignoreLocator({ by, value, reason: 'Manually ignored' });
      await dispatch(loadDriftIgnoreListAsync());
      return { by, value };
    } catch (error) {
      return rejectWithValue(errorMessage(error));
    }
  },
);

const screenDriftSlice = createSlice({
  name: 'screenDrift',
  initialState: {
    grouped: [],
    groupedLoading: false,
    groupedError: null,
    comparison: null,
    comparing: false,
    error: null,
    showTestImpactOnly: true,
    showIgnored: false,
  },
  reducers: {
    setScreenDriftShowTestImpactOnly(state, action) {
      state.showTestImpactOnly = action.payload;
    },
    setScreenDriftShowIgnored(state, action) {
      state.showIgnored = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchScreenDriftGroupedAsync.pending, (state) => {
        state.groupedLoading = true;
        state.groupedError = null;
      })
      .addCase(fetchScreenDriftGroupedAsync.fulfilled, (state, action) => {
        state.groupedLoading = false;
        state.grouped = Array.isArray(action.payload) ? action.payload : [];
      })
      .addCase(fetchScreenDriftGroupedAsync.rejected, (state, action) => {
        state.groupedLoading = false;
        state.groupedError = action.payload;
      })
      .addCase(compareScreenDriftAsync.pending, (state) => {
        state.comparing = true;
        state.error = null;
      })
      .addCase(compareScreenDriftAsync.fulfilled, (state, action) => {
        state.comparing = false;
        state.comparison = action.payload;
      })
      .addCase(compareScreenDriftAsync.rejected, (state, action) => {
        state.comparing = false;
        state.error = action.payload;
      });
  },
});

export const { setScreenDriftShowIgnored, setScreenDriftShowTestImpactOnly } =
  screenDriftSlice.actions;

export default screenDriftSlice.reducer;
